<template>
	<div>
		<div v-if="anwesenheitsgrund" class="panel m-5">
			<p class="panel-heading">
				Anwesenheitsgrund
			</p>
			<div class="columns">
				<div class="column">
					<b-field label="Bezeichner">
						<p class="content">
							{{ anwesenheitsgrundName }}
						</p>
					</b-field>
				</div>
				<div class="column">
					<b-field label="Farbe">
						<div style="text-align: center; display: inline-block;">
							<div class="content" style="width:30px; height:30px;"
								:style="{ 'background-color': anwesenheitsgrundColor.hex }">
							</div>
						</div>
					</b-field>
				</div>
				<div class="column">
					<b-field label="Kürzel">
						<p class="content">
							{{ anwesenheitsgrundHint }}
						</p>
					</b-field>
				</div>
			</div>
		</div>
		<section class="m-2">
			<b-button class="is-danger" tag="router-link" to="/anwesenheit">
				Zurück
			</b-button>
		</section>
	</div>
</template>

<script>
export default {
	name: "ViewAnwesenheitsgrund",
	data() {
		return {
			anwesenheitsgrund: undefined,
			anwesenheitsgrundName: "",
			anwesenheitsgrundColor: {
				"hex": "#000000",
				"source": "hex"
			},
			anwesenheitsgrundHint: "",
		};
	},
	computed: {},
	mounted() {
		this.scrollToElement()
		if (this.$route.params.data) {
			this.anwesenheitsgrund = this.$route.params.data
			this.anwesenheitsgrundName = this.anwesenheitsgrund.attributes.name
			this.anwesenheitsgrundColor.hex = this.anwesenheitsgrund.attributes.color
			this.anwesenheitsgrundHint = this.anwesenheitsgrund.attributes.hint
		}
	},
	methods: {
		scrollToElement() {
			const el = this.$parent.$parent.$refs.scrollToMe;
			if (el) {
				el.scrollIntoView({ behavior: 'smooth' });
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.image_column {
	max-width: 200px;
}
</style>
